import script from "./form-region.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-region.vue?vue&type=script&setup=true&lang=ts"

import "./form-region.vue?vue&type=style&index=0&id=39439c05&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39439c05"]])

export default __exports__